import { Table } from 'antd'

import type { ITableProps } from '../types'
import type { IDataSecurityData } from './types'

function DataSecurity({ columns, dataSource, rowKey }: ITableProps<IDataSecurityData>): JSX.Element {
  return (
    <Table
      className="organization-table"
      dataSource={dataSource}
      columns={columns}
      rowKey={rowKey}
      pagination={false}
    />
  )
}

export default DataSecurity
